require('./mortgageRequestMovingExpensesSuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKLink } = require('commonsComponents/OKLink');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

//@ helpers
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp.js');

class MortgageRequestMovingExpensesSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.handleBackToPanelClick = this.handleBackToPanelClick.bind(this);
    }

    componentDidMount() {
        const { onRequestMontlyFee, mortgageRequestMortgageData } = this.props;
        const financeExpensesValue = mortgageRequestMortgageData.getIn(['data', 'importeFinanciarGastos']);

        if (!!financeExpensesValue) {
            onRequestMontlyFee(financeExpensesValue);
        }
    }

    handleBackToPanelClick() {
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleShowMortgageConditions() {
        this.props.history.push('/myprofile/mortgage/conditions');
    }

    isNewOfferSelected() {
        const { mortgageRequestMortgageData, } = this.props;

        return !!mortgageRequestMortgageData.getIn(['data', 'importeFinanciarGastos']);
    }

    buildAmountsContent(keyPrefix) {
        const { mortgageRequestMovingExpensesData, mortgageRequestMortgageData } = this.props;
        const formattedExpenses = MortgageRequestCurrencyHelp({ currency: mortgageRequestMortgageData.getIn(['data', 'importeFinanciarGastos']) });
        const formattedFee = MortgageRequestCurrencyHelp({ currency: mortgageRequestMovingExpensesData.get('newOffer') });

        return (
            <div className="mortgage-request-moving-expenses-success__amounts">
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        className="mortgage-request-moving-expenses-success__amounts-box-left"
                        onlyChildren
                    >
                        <FormattedText
                            value={`${keyPrefix}expensesTitle`}
                            className="mortgage-request-moving-expenses-success__amounts-title"
                        />
                        <span className="mortgage-request-moving-expenses-success__amounts-title-separator"></span>
                        <span className="mortgage-request-moving-expenses-success__amounts-value">
                            {formattedExpenses}
                        </span>
                    </OKInformativeListItem>
                    <OKInformativeListItem onlyChildren>
                        <FormattedText
                            value={`${keyPrefix}feeTitle`}
                            className="mortgage-request-moving-expenses-success__amounts-title"
                        />
                        <span className="mortgage-request-moving-expenses-success__amounts-title-separator"></span>
                        <span className="mortgage-request-moving-expenses-success__amounts-value">
                            {formattedFee}
                        </span>
                    </OKInformativeListItem>
                </OKInformativeList>
            </div>
        );
    }

    render() {
        const keyPrefix = 'mortgageRequestMovingExpensesSuccess-mortgageRequestMovingExpensesSuccess_';
        const titleKey = this.isNewOfferSelected() ? `${keyPrefix}title` : `${keyPrefix}titleNoExpenses`;
        const title = formatText(titleKey);
        const contentKey = this.isNewOfferSelected() ? `${keyPrefix}paragraph` : `${keyPrefix}paragraphNoExpenses`;
        const amountsContent = this.isNewOfferSelected() ? this.buildAmountsContent(keyPrefix) : null;

        return (
            <ContentBox>
                <i className="mortgage-request-moving-expenses-success__icon-success" />
                <div className="mortgage-request-moving-expenses-success">
                    <OKBoxTitle value={title} />
                    <FormattedText
                        value={contentKey}
                        className="mortgage-request-moving-expenses-success__content"
                    />
                    {amountsContent}
                    <div className="mortgage-request-moving-expenses-success__links">
                        <span className="mortgage-request-moving-expenses-success__links-button">
                            <OKLink
                                id="conditionsLink"
                                modifier="inherit-styles"
                                to="/myprofile/mortgage/conditions"
                            >
                                <FormattedText value="mortgageRequestMovingExpensesSuccess-mortgageRequestMovingExpensesSuccess_conditionsLinkLabel" />
                            </OKLink>
                        </span>
                        <span className="mortgage-request-moving-expenses-success__links-button">
                            <OKLink
                                id="panelLink"
                                modifier="inherit-styles"
                                to="/myprofile/mortgage/panel"
                            >
                                <FormattedText value="mortgageRequestMovingExpensesSuccess-mortgageRequestMovingExpensesSuccess_panelLinkLabel" />
                            </OKLink>
                        </span>
                    </div>
                </div >
            </ContentBox>
        );
    }
}

MortgageRequestMovingExpensesSuccess.propTypes = {
    onRequestMontlyFee: PropTypes.func,
    onCancelMovingExpensesCurrentOffer: PropTypes.func,
    mortgageRequestMortgageData: PropTypes.object,
    mortgageRequestMovingExpensesData: PropTypes.object,
    history: PropTypes.object.isRequired
}
module.exports = withRouter(MortgageRequestMovingExpensesSuccess);
